import request from "@/utils/request";

export default function agentEditDeviceSocketSize(data) {
    return request({
        url: `/device/device/agentEditDeviceSocketSize`,
        method: 'post',
        data
    })
}
